// src/components/RemarkModal.js
import React, { useState, useEffect } from "react";
import API_BASE_URL from "../apiConfig";

const RemarkModal = ({ isOpen, section, modalTitle, onClose, userID, selectedDate }) => {
  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);

  // Default friendly section names
  const sectionTitles = {
    A: "Sales Cash Balance",
    B: "Sale Summary",
    C: "Quantitative Information",
  };

  // Fetch existing remark when modal opens
  useEffect(() => {
    if (isOpen && section && selectedDate && userID) {
      fetch(`${API_BASE_URL}/api/eod_remark.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "fetch",
          section,
          userID,
          selectedDate,
        }),
      })
        .then((res) => res.json())
        .then((data) => setRemark(data.remark || ""))
        .catch((err) => console.error("Fetch remark failed:", err));
    }
  }, [isOpen, section, selectedDate, userID]);

  // Save remark
  const handleSave = () => {
    if (!remark.trim()) {
      alert("Please enter a remark.");
      return;
    }

    setLoading(true);
    fetch(`${API_BASE_URL}/api/eod_remark.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        action: "save",
        section,
        userID,
        selectedDate,
        remark,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) alert(data.message || "Remark saved!");
        else alert(data.message || "Failed to save.");
        onClose();
      })
      .catch((err) => alert("Error saving remark: " + err))
      .finally(() => setLoading(false));
  };

  // Clear remark
  const handleClear = () => setRemark("");

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        {/* Dynamic title */}
        <h3>{modalTitle || `Remarks - ${sectionTitles[section] || section}`}</h3>

        <textarea
          value={remark}
          onChange={(e) => {
            if (e.target.value.length <= 800) {
              setRemark(e.target.value);
            }
          }}
          rows="5"
          cols="40"
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            marginBottom: "5px",
            resize: "none",
            fontSize: "14px",
          }}
        />

        {/* Character counter */}
        <div
          style={{
            textAlign: "right",
            fontSize: "12px",
            marginBottom: "15px",
            color: remark.length >= 750 ? "red" : "grey",
          }}
        >
          {remark.length}/800
        </div>

        <div className="modal-actions">
          <button onClick={handleSave} disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>
          <button onClick={handleClear} type="button">
            Clear
          </button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default RemarkModal;
